import { connect } from "react-redux";
import { requestUserLogout } from "../../redux/actions";
import ContentWrapper from "./ContentWrapper";

export default connect(null, {
    requestUserLogout
})(ContentWrapper)
